import { render, staticRenderFns } from "./ZealStudentSpecificICardPrint.vue?vue&type=template&id=0326c58a&scoped=true&"
import script from "./ZealStudentSpecificICardPrint.vue?vue&type=script&lang=js&"
export * from "./ZealStudentSpecificICardPrint.vue?vue&type=script&lang=js&"
import style0 from "./ZealStudentSpecificICardPrint.vue?vue&type=style&index=0&id=0326c58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326c58a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VRow})
